import React, { useState } from "react";
import { Table, Row, Col, Button, Space, message } from "antd";
import PerformanceHistoryModal from "./PerformanceHistoryModal";
import { removeTerminatedContracts } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { TerminatedContractsColumns } from "../../../../PQQ/tableColumns";

const PerformanceHistory = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchTerminatedContracts();
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeTerminatedContracts({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...TerminatedContractsColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Contract
        </Button>
        <Table
          size="small"
          columns={columns}
          dataSource={props.terminatedContractsData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>

      {visible && (
        <PerformanceHistoryModal
          setVisible={setVisible}
          title="Add Contract"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default PerformanceHistory;
